import clsx from "clsx";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import React from "react";
import { Clock } from "react-feather";
import IconRoundel from "./IconRoundel";

dayjs.extend(utc);
dayjs.extend(timezone);

const EventTime = ({ event, iconTheme = "light" }) => {
  const eventStart = dayjs(event.startDateTime).tz("Europe/London");
  const eventStartFormatted = eventStart.format("h:mma");
  const eventEnd = dayjs(event.endDateTime).tz("Europe/London");
  const eventEndFormatted = eventEnd.format("h:mma");

  return (
    <div className={clsx("flex items-center space-x-3")}>
      <IconRoundel icon={Clock} theme={iconTheme} />
      <div className={clsx("space-x-1")}>
        <span>
          {eventStartFormatted} — {eventEndFormatted}
        </span>
        <span className={clsx("text-sm text-gray-500")}>UK time</span>
      </div>
    </div>
  );
};

export default EventTime;
